/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const POST_BATTLE_BATTLE_LIST_OUTCOMES = {
    victory: (
        <FormattedMessage
            id='post_battle_battles_outcome.victory'
            defaultMessage='Победа!'
        />
    ),
    defeat: (
        <FormattedMessage
            id='post_battle_battles_outcome.defeat'
            defaultMessage='Поражение'
        />
    ),
    draw: (
        <FormattedMessage
            id='post_battle_battles_outcome.draw'
            defaultMessage='Ничья'
        />
    ),
}



// WEBPACK FOOTER //
// ./containers/PostbattleScreen/components/BattleList/constants.jsx